import React, { MutableRefObject } from 'react';
import { makeStyles } from "@material-ui/core";
import BarLoader from '../../../components/BarLoader/BarLoader';
import classNames from 'classnames';
import { Colors } from '../../../styles/Colors';

const AccountDashboardLoader: React.VFC<{
    loaderRef?: MutableRefObject<HTMLDivElement | null>
}> = ({
    loaderRef
}) => {
    const classes = useStyles();

    return (
        <div ref={loaderRef} className={classes.callEntry}>
            <div className={classes.callEntryLeftItem}>
                <div className={classes.callerAnimatedIcon}>
                    <BarLoader containerClass={classes.barLoader} backgroundColor={Colors.LightGraySecondary4} />
                </div>
                <div className={classNames(classes.callDetailsContainer, classes.callDetailsContainerAnimated)}>
                    <div className={classes.caller}>
                        <BarLoader containerClass={classes.barLoader} backgroundColor={Colors.LightGraySecondary4} />
                    </div>
                    <div className={classes.secondLineContainer}>
                        <div className={classNames(classes.callerExt, classes.callDetailsContainerAnimated)}>
                            <BarLoader containerClass={classes.barLoader} backgroundColor={Colors.LightGraySecondary4} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={classNames(classes.callEntryRightItem, classes.callDetailsContainerAnimated)}>
                <BarLoader />
            </div> 
        </div>
    );
};

const useStyles = makeStyles(() => ({
    callEntry: {
        width: 'calc(100% - 32px)',
        padding: '11px 16px',
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 34,

        '&:hover': {
            background: 'rgba(232, 250, 255, 1)',
            borderLeft: '4px solid rgba(81, 166, 237, 1)',
            paddingLeft: 12,
        }
    },
    callEntryLeftItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    callEntryRightItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    callDetailsContainer: {
        width: 'fit-content',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        marginLeft: 12
    },
    caller: {
        fontWeight: 700,
        fontSize: 14,
        color: 'rgba(38, 50, 56, 1)',
        lineHeight: '16px'
    },
    callerExt: {
        fontWeight: 400,
        fontSize: 12,
        color: 'rgba(120, 144, 156, 1)',
        lineHeight: '14px',
    },
    secondLineContainer: {
        width: 'fit-content',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        lineHeight: '14px',
    },
    barLoader: {
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        borderRadius: 17,
        marginBottom: 2
    },
    callerAnimatedIcon: {
        width: 34,
        height: 34,
    },
    callDetailsContainerAnimated: {
        width: 190,
        userSelect: 'none'
    },
}));

export default AccountDashboardLoader;